// src/utils/api.js
// Dynamically detect API base URL
const getApiRoot = () => {
  // If environment variable is set, use it (for local development)
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }

  // In production, use the current domain (works for both millmind.ai and jmc.aiguru.pro)
  if (typeof window !== 'undefined') {
    const protocol = window.location.protocol;
    const host = window.location.host;
    return `${protocol}//${host}`;
  }

  // Fallback for local development
  return 'http://localhost:8001';
};

const ROOT = getApiRoot().replace(/\/+$/, ''); // strip trailing slashes

export const API  = `${ROOT}/api`;            // for routes defined with prefix="/api"
export const ROOT_API = ROOT;                 // for /health, /upload-document, etc.
